import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Row, Col } from "react-bootstrap";
import { DEVELOPMENT_TYPE } from "Constants";
import ModuleItem from "./module-item";
import ListItem from "FeaturesItem";
import LocaleStrings from "Languages";

class Features extends Component {
  constructor(props) {
    super(props);

    this.submitFeaturesData = this.submitFeaturesData.bind(this);
  }

  renderContentItems() {
    if (this.props.selectedFeatures.length % 2 > 0) {
      let obj = {
        apptabid: 0,
        bsClass: "",
        description: "",
        isenabled: true,
        label: "extra_blank",
        taborder: 0,
      };
      this.props.selectedFeatures.push(obj);
    }

    var items = _.map(this.props.selectedFeatures, (feature) => (
      <ListItem key={feature.bsClass} feature={feature} />
    ));
    return items;
  }

  renderAppItems() {
    let { actionAppModules } = this.props;
    // if (actionAppModules.length % 3 > 0) {
    //   let obj = {
    //     apptabid: 0,
    //     bsClass: "",
    //     description: "",
    //     isenabled: true,
    //     iconName: "extra_blank",
    //     taborder: 0,
    //   };
    //   actionAppModules.push(obj);
    // }
    var items = _.map(actionAppModules, (module) => (
      <ModuleItem key={module.iconName} module={module} />
    ));
    return items;
  }

  submitFeaturesData() {
    let { selectedFeatures, actionAppModules, appBottomMenu, displaySection } =
      this.props;
    let full = _.concat(selectedFeatures, actionAppModules);

    // This part is used currently in koachify, but this condition we can alos check in eventify if required. Here displaySection props is sending from parent component
    if (displaySection && displaySection === "content") {
      full = _.concat(selectedFeatures);
    }
    this.props.submitFeaturesDataHandler(full, appBottomMenu);
  }

  render() {
    let { displaySection } = this.props;

    return DEVELOPMENT_TYPE === "koachify" ? (
      <div className="main-content-body">
        <Row>
          {displaySection && displaySection === "content" ? (
            <Col md={12}>
              <ul className="feature-ul ul-list-column2">
                {this.renderContentItems()}
              </ul>
            </Col>
          ) : (
            <Col md={12}>
              {/* <div className="features-sub-header">{LocaleStrings.features_text_modules}</div> */}
              <ul className="feature-ul ul-list-column3">
                {this.renderAppItems()}
              </ul>
            </Col>
          )}
        </Row>
      </div>
    ) : (
      <Row>
        <Col md={6} lg={4} xs={12} sm={12} className="border-right">
          {/* <div className="features-sub-header">{LocaleStrings.features_text_modules}</div> */}
          <ul className="feature-ul">{this.renderAppItems()}</ul>
        </Col>
        <Col md={6} lg={8} xs={12} sm={12}>
          {/* <div className="features-sub-header">{LocaleStrings.features_text_contents}</div> */}
          <ul className="feature-ul ul-list-column2">
            {this.renderContentItems()}
          </ul>
        </Col>
      </Row>
    );
  }
}

function mapStateToProps(state) {
  // debugger;
  // console.log("state.actionAppModules :- ", state.actionAppModules);

  return {
    session: state.session,
    selectedFeatures: state.selectedFeatures,
    actionAppModules: state.actionAppModules,
    appBottomMenu: state.appBottomMenu,
  };
}

export default connect(mapStateToProps, {}, null, {
  forwardRef: true,
})(Features);
